import enUS from "./utility/lang/en-US";
import enGB from "./utility/lang/en-GB";
import {get} from "./utility/via-fetch";

const PURCO_DEFAULT = false; //default for usages before set - false (set to true on PurCo environments)
let purcoInstall = false;

export const isPurCoInstall = () => {
    return purcoInstall;
};

export const getInfoEmailDetails = () => {
    if (isPurCoInstall()) {
        return {
            email: "contactus@purinspect.com",
            subject: "PurInspect",
        };
    } else {
        return {
            email: "info@moblyx.com",
            subject: "M-Inspect",
        };
    }
};

export const getDefaultLocale = () => {
    return isPurCoInstall() ? enUS : enGB;
}

export default {};

export const setPurcoInstallIndicator = async () => {
    purcoInstall = PURCO_DEFAULT;
    try {
        const indicator = await get(`/api/application-configurations/PURCO_INSTALL`, undefined, {})
        if (indicator) {
            purcoInstall = indicator.applicationConfigValue.toUpperCase() === 'TRUE';
        }
    } catch (error) {
        purcoInstall = PURCO_DEFAULT;
    }
}